import './XYChartTooltipTemplate.css';
export var body = '_fnoz5j0-3-5-0';